// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"272d0268","963":"c4197ab4"}[chunkId] + ".chunk.js";
};